function useAppBridge() {
  const {
    pina_systemInfo,
    pina_merchatInfo,
    pina_displayMerchatInfo,
    pina_certificationInfo,
    pina_terminalInfo,
    pina_temporaryData,
  } = storeToRefs(model.pinia_custom())

  const { Auth } = model.pinia_custom()

  // 在 hook 初始化时就执行环境检查
  const appEnv = ref({
    isAndroid: false,
    isIOS: false,
    isApp: false,
    platform: '',
  })
  initAppEnv()

  // 初始化App环境
  function initAppEnv() {
    const platform = uni.getSystemInfoSync().platform
    appEnv.value = {
      isIOS: platform === 'ios',
      isAndroid: platform === 'android',
      isApp: platform === 'ios' || platform === 'android',
      platform,
    }
    // console.log('🚀 ~ initAppEnv ~ appEnv.value:', appEnv.value)
  }

  /*判断客户端*/
  function judgeClient() {
    let u = navigator.userAgent
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //判断是否是 android终端
    let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //判断是否是 iOS终端
    if (isAndroid) {
      return 'Android'
    } else if (isIOS) {
      return 'IOS'
    } else {
      return 'PC'
    }
  }

  // 清理信息
  const clearInfo = () => {
    pina_systemInfo.value.token = null
    Auth.setToken(pina_systemInfo.value.token)
    pina_systemInfo.value.userId = null
    pina_systemInfo.value.agtMercId = null
    pina_merchatInfo.value = {}
    pina_displayMerchatInfo.value = null
    pina_certificationInfo.value = {}
    pina_terminalInfo.value = null
    pina_temporaryData.value = null
  }

  // App 方法集合
  const appMethods = {
    // 获取系统信息
    getSystemInfo: () => {
      try {
        return new Promise((resolve) => {
          // 注册 H5 端回调方法,用于接收 App 调用的响应
          window.testH5Func = function (info) {
            let val
            try {
              if (typeof info === 'string') {
                val = JSON.parse(info)
              } else {
                val = JSON.parse(JSON.stringify(info))
              }
              resolve(val)
            } catch (error) {
              console.log('解析数据失败:', error)
              resolve(null)
            }
          }

          try {
            if (appEnv.value.isAndroid) {
              window?.android?.paramsTest()
            } else if (appEnv.value.isIOS) {
              window?.webkit?.messageHandlers?.paramsTest?.postMessage(null)
            }
          } catch (error) {
            console.log('调用原生方法失败:', error)
            resolve(null)
          }
        })
      } catch (error) {
        console.log('🚀 ~ useAppBridge ~ error:', error)
        return Promise.resolve(null)
      }
    },

    // 返回 App
    goBackNative: () => {
      try {
        if (appEnv.value.isAndroid) {
          window?.android?.goBackNative('backApp')
        } else if (appEnv.value.isIOS) {
          window?.webkit?.messageHandlers?.goBackNative?.postMessage('backApp')
        }
      } catch (error) {
        console.error('返回 App 失败:', error)
      }
    },
    // 返回 APP 登录页
    toLogin: () => {
      if (appEnv.value.isAndroid) {
        window?.android?.toLogin()
      } else if (appEnv.value.isIOS) {
        window?.webkit?.messageHandlers?.toLogin?.postMessage(null)
      }
    },
    // 退出登录
    logout: () => {
      try {
        // clearInfo()
        if (pina_systemInfo.value.backApp === 'homepage') {
          appMethods.goBackNative()
        } else {
          appMethods.toLogin()
        }
      } catch (error) {
        console.error('退出登录失败:', error)
      }
    },

    // 扫码
    scan: (type = '3', callback) => {
      return new Promise((resolve) => {
        // 注册扫码回调
        window.getScanInfo = function (info) {
          callback?.(info)
          resolve(info)
        }

        try {
          if (appEnv.value.isAndroid) {
            window?.android?.toScanCode(type)
          } else if (appEnv.value.isIOS) {
            window?.webkit?.messageHandlers?.toScanCode?.postMessage(type)
          }
        } catch (error) {
          console.error('调用扫码失败:', error)
          resolve(null)
        }
      })
    },

    // 设置媒体音量
    setMediaVolume: (volume) => {
      try {
        if (appEnv.value.isAndroid) {
          window?.android?.setMediaVolume(volume)
        } else if (appEnv.value.isIOS) {
          window?.webkit?.messageHandlers?.setMediaVolume?.postMessage(volume)
        }
      } catch (error) {
        console.error('设置音量失败:', error)
      }
    },

    // 原生导航
    navigate: (url = '') => {
      try {
        if (appEnv.value.isAndroid) {
          window?.android?.useNativeNav(url)
        } else if (appEnv.value.isIOS) {
          window?.webkit?.messageHandlers?.useNativeNav?.postMessage(url)
        }
      } catch (error) {
        console.error('导航失败:', error)
      }
    },

    // 打开相机
    openCamera: () => {
      return new Promise((resolve) => {
        // 注册相机回调
        window.nativeCamera = function (url) {
          resolve(url)
        }

        try {
          if (appEnv.value.isIOS) {
            window?.webkit?.messageHandlers?.openNativeCamera?.postMessage(null)
          }
        } catch (error) {
          console.error('打开相机失败:', error)
          resolve(null)
        }
      })
    },

    // 返回上一层
    goBack: () => {
      try {
        if (appEnv.value.isAndroid) {
          window?.android?.webBackPreLayer()
        } else if (appEnv.value.isIOS) {
          window?.webkit?.messageHandlers?.webBackPreLayer?.postMessage(null)
        }
      } catch (error) {
        console.error('返回失败:', error)
      }
    },

    // 打开浏览器
    openBrowser: (url) => {
      try {
        if (appEnv.value.isAndroid) {
          window?.android?.toNativeBrowser(url || '')
        } else if (appEnv.value.isIOS) {
          window?.webkit?.messageHandlers?.toNativeBrowser?.postMessage(url || null)
        }
      } catch (error) {
        console.error('打开浏览器失败:', error)
      }
    },

    // 设置图片压缩忽略大小
    setImgCompressIgnoreSize: (size = '500') => {
      try {
        if (appEnv.value.isAndroid) {
          window?.android?.imgCompressIgnoreSize(size)
        } else if (appEnv.value.isIOS) {
          // iOS 暂不支持
        }
      } catch (error) {
        console.error('设置图片压缩大小失败:', error)
      }
    },
  }

  // 获取导航栏高度
  const getNavBarHeight = (isUnit = false, isFilter = false) => {
    const navHeight = 88
    const filterHeight = 100
    const safeHeight = Number(pina_systemInfo.value.nativeSafeHeight || 0)

    if (appEnv.value.isApp || isFilter) {
      let calcHeight = navHeight + safeHeight
      if (isFilter) {
        calcHeight += filterHeight
      }
      return isUnit ? calcHeight : `${calcHeight}rpx`
    }

    return isUnit ? 0 : '0rpx'
  }

  // 生命周期钩子
  onMounted(() => {
    initAppEnv()
  })

  onUnmounted(() => {
    // 清理全局方法
    delete window.testH5Func
    delete window.getScanInfo
    delete window.nativeCamera
  })

  return {
    appEnv,
    appMethods,
    getNavBarHeight,
    clearInfo,
  }
}
export { useAppBridge }
